import React from 'react';
import ChevronIcon from 'components/assets/ChevronIcon';
import A from 'components/atoms/A/A';
import classes from './BackButton.module.scss';
import clsx from 'clsx';

export interface Props {
  to?: string;
  onClick?: () => void;
  hasNoTopMargin?: boolean;
}

const BackButton: React.FC<Props> = ({ onClick, to, hasNoTopMargin }: Props) => {
  if (to) {
    return (
      <A
        href={to}
        className={clsx(classes.backBtn, hasNoTopMargin && classes.noTopMargin)}
        aria-label="back"
      >
        <ChevronIcon color="#1c2451" />
      </A>
    );
  } else {
    return (
      <button
        onClick={onClick}
        className={clsx(classes.backBtn, hasNoTopMargin && classes.noTopMargin)}
        aria-label="back"
      >
        <ChevronIcon color="#1c2451" />
      </button>
    );
  }
};

export default BackButton;
